import { spacing as spacingTokensThemed } from '@orus.eu/design-tokens/tokens/spacing-tokens.json'

export type Spacing = 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100

export const spacing = Object.keys(spacingTokensThemed.light).reduce(
  (styles, tokenName) => ({
    ...styles,
    [tokenName.replace('spacing-', '')]: `var(--${tokenName})`,
  }),
  {} as Record<Spacing, string>,
)

export const spacingPx = Object.entries(spacingTokensThemed.light).reduce(
  (values, [tokenName, raw]) => ({
    ...values,
    [tokenName.replace('spacing-', '')]: Number.parseFloat(raw),
  }),
  {} as Record<Spacing, number>,
)
